import {
  Controller
} from 'stimulus';
import StimulusReflex from 'stimulus_reflex';

// While a reflex runs, body.wait pulses the logo. The controller callbacks
// below clear it, but they never fire when the reflex's own element is
// morphed away (e.g. the confirm button in a modal that the update replaces),
// so these page-level events clear it too, with a timeout as a last resort.
let waitTimer;

function clearWait() {
  clearTimeout(waitTimer);
  document.body.classList.remove('wait');
}

['stimulus-reflex:finalize', 'cable-ready:after-morph', 'turbolinks:load'].forEach((event) => {
  document.addEventListener(event, clearWait);
});

/* This is your ApplicationController.
 * All StimulusReflex controllers should inherit from this class.
 *
 * Example:
 *
 *   import ApplicationController from './application_controller'
 *
 *   export default class extends ApplicationController { ... }
 *
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends Controller {
  connect() {
    StimulusReflex.register(this);
  }

  /* Application-wide lifecycle methods
   *
   * Use these methods to handle lifecycle concerns for the entire application.
   * Using the lifecycle is optional, so feel free to delete these stubs if you don't need them.
   *
   * Arguments:
   *
   *   element - the element that triggered the reflex
   *             may be different than the Stimulus controller's this.element
   *
   *   reflex - the name of the reflex e.g. "Example#demo"
   *
   *   error/noop - the error message (for reflexError), otherwise null
   *
   *   reflexId - a UUID4 or developer-provided unique identifier for each Reflex
   */

  beforeReflex(element, reflex, noop, reflexId) {
    document.body.classList.add('wait');
    clearTimeout(waitTimer);
    waitTimer = setTimeout(clearWait, 15000);
  }

  reflexSuccess(element, reflex, noop, reflexId) {
    // show success message etc...
    // todo: should add a flash success message here. the message can be in an element data attr
    clearWait();
  }

  reflexError(element, reflex, error, reflexId) {
    // show error message etc...
    // todo: should add a flash error message here
    clearWait();
  }
}